/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Style_CodeInputs */

const en_field_style_code = /** @type {(inputs: Field_Style_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style code`)
};

/**
* | output |
* | --- |
* | "Style code" |
*
* @param {Field_Style_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_style_code = /** @type {((inputs?: Field_Style_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Style_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_style_code(inputs)
});